// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var initialState_firstName = null;

var initialState_lastName = null;

var initialState_email = null;

var initialState_password = null;

var initialState_phoneNumber = null;

var initialState = {
  firstName: initialState_firstName,
  lastName: initialState_lastName,
  email: initialState_email,
  password: initialState_password,
  phoneNumber: initialState_phoneNumber,
  marketingOptIn: false
};

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* Step1Update */0 :
        return {
                firstName: action.firstName,
                lastName: action.lastName,
                email: state.email,
                password: state.password,
                phoneNumber: state.phoneNumber,
                marketingOptIn: state.marketingOptIn
              };
    case /* Step2Update */1 :
        return {
                firstName: state.firstName,
                lastName: state.lastName,
                email: action.email,
                password: state.password,
                phoneNumber: state.phoneNumber,
                marketingOptIn: state.marketingOptIn
              };
    case /* Step3Update */2 :
        return {
                firstName: state.firstName,
                lastName: state.lastName,
                email: state.email,
                password: action.password,
                phoneNumber: state.phoneNumber,
                marketingOptIn: state.marketingOptIn
              };
    case /* Step4Update */3 :
        return {
                firstName: state.firstName,
                lastName: state.lastName,
                email: state.email,
                password: state.password,
                phoneNumber: action.phoneNumber,
                marketingOptIn: action.marketingOptIn
              };
    
  }
}

function useOnboardingReducer(param) {
  return React.useReducer(reducer, initialState);
}

export {
  initialState ,
  reducer ,
  useOnboardingReducer ,
}
/* react Not a pure module */
